import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/base.service';
import { DealerRep } from './dealer-rep.model';

@Injectable({
    providedIn: 'root'
})

export class DealerRepService extends BaseService {

    public getDealerReps(idToken: string, searchParams: any, pageSize: number, pageIndex: number) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "last-name", searchParams.lastName);
        queryParams = this.appendQueryParam(queryParams, "first-name", searchParams.firstName);
        queryParams = this.appendQueryParam(queryParams, "email", searchParams.email);
        queryParams = this.appendQueryParam(queryParams, "dealer-id", searchParams.dealerId);
        queryParams = this.appendQueryParam(queryParams, "dealer-rep-id", searchParams.dealerRepId);
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/dealer-reps`, { headers, params: queryParams });
    }

    public getDealerRep(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/dealer-rep/${id}`, { headers });
    }

    public addDealerRep(idToken: string, dealerRep: DealerRep) {
        const body = JSON.stringify(dealerRep);
        const headers = this.getHeaders(idToken);
        return this.httpClient.post(`${this.backendDomain}/dealer-rep`, body, { headers });
    }

    public updateDealerRep(idToken: string, dealerRep: DealerRep) {
        const body = JSON.stringify(dealerRep);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer-rep/${dealerRep.id}`, body, { headers });
    }

    public inactivateDealerRep(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer-rep/inactivate/${id}`, {}, { headers });
    }

    public reactivateDealerRep(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer-rep/reactivate/${id}`, {}, { headers });
    }

    public deleteDealerRepLogical(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer-rep/delete/${id}`, {}, { headers });
    }

    public deleteDealerRep(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/dealer-rep/${id}`, { headers });
    }
}